function hexToRgb(hex: string) {
    if (!hex) return null;
    let value = hex.trim();
    if (value.startsWith("rgb")) {
        const match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
        if (!match) return null;
        return { r: Number(match[1]), g: Number(match[2]), b: Number(match[3]) };
    }
    if (value[0] === "#") value = value.slice(1);
    if (value.length === 3) {
        value = value.split("").map((ch) => ch + ch).join("");
    }
    if (value.length !== 6) return null;
    const num = parseInt(value, 16);
    if (Number.isNaN(num)) return null;
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

function rgbToHex({ r, g, b }: { r: number; g: number; b: number }) {
    const toHex = (n: number) => n.toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function mixWithWhite({ r, g, b }: { r: number; g: number; b: number }, ratio: number) {
    const mix = (channel: number) => Math.round(channel + (255 - channel) * ratio);
    return { r: mix(r), g: mix(g), b: mix(b) };
}

function setBrandTints(color: string | null | undefined) {
    const root = document.documentElement;
    const computed = getComputedStyle(root).getPropertyValue("--main-color");
    const base = (color || computed || "").trim();
    const rgb = hexToRgb(base);
    if (!rgb) {
        if (base) root.style.setProperty("--brand-strong", base);
        return;
    }
    root.style.setProperty("--brand-strong", rgbToHex(rgb));
    root.style.setProperty("--brand-soft", rgbToHex(mixWithWhite(rgb, 0.75)));
    root.style.setProperty("--brand-softer", rgbToHex(mixWithWhite(rgb, 0.88)));
}

// Aplica color/fuente/footer/favicon del tenant a las variables CSS globales.
export function applyBrandTheme(shared: any) {
    if (!shared) return;
    const root = document.documentElement;

    if (shared.ButtonsColor !== null && shared.ButtonsColor !== undefined) {
        root.style.setProperty("--main-color", shared.ButtonsColor);
    }
    setBrandTints(shared.ButtonsColor);

    if (shared.FontFamily !== null && shared.FontFamily !== undefined) {
        root.style.setProperty("--main-family", shared.FontFamily);
    }
    if (shared.FooterColor !== null && shared.FooterColor !== undefined) {
        root.style.setProperty("--main-footercolor", shared.FooterColor);
    }

    if (shared.Mainlogo) {
        const logo = shared.Uploads + "/" + shared.Mainlogo;
        let link: any = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }
        link.href = logo;
    }
}
